export default __webpack_public_path__ + "static/media/logo.d597021c.svg";